<template>
  <van-cell>
    <span slot="title">
      {{ passenger.passengerName }}
      <van-tag
        v-if="passenger.fsEmpId"
        class="m-r-5"
        type="danger"
      >{{ $t('attach','附') }}</van-tag>

      <van-tag plain>{{ passenger.ticketTypeName }}</van-tag>
    </span>

    <!-- 左侧内容 -->
    <div
      class="font12"
      slot="label"
    >
      <p>
        {{ passenger.idTypeName }}
        {{ passenger.idCode ? passenger.idCode.replace(/^(.{4})(?:\w+)(.{4})$/,
                                                       "\$1******\$2") : "" }}
      </p>
      <p v-if="passenger.ticketCode">
        {{ $t('F005','票号') }} {{ passenger.ticketCode }}
      </p>
    </div>

    <!-- 右侧内容 -->
    <p class="font12">
      <span>{{ passenger.seatCode }}</span>
    </p>
    <p class="font12">
      {{ passenger.seatTypeName }} <span class="money-color">{{ passenger.ticketPriceStr }}</span>
    </p>
    <p class="font12">
      {{ $t('E001','服务费') }} <span class="money-color">{{ passenger.sellServiceChargeStr }}</span>
    </p>
  </van-cell>
</template>

<script>
import { Cell, Tag } from 'vant'

export default {
  components: {
    [Cell.name]: Cell,
    [Tag.name]: Tag
  },
  props: {
    passenger: {
      type: Object,
      default: () => {}
    }
  }

}
</script>

<style lang="less" scoped>
.m-r-5{
  margin-right: 5px;
}
.van-tag {
  vertical-align: text-bottom;
}
.van-cell__title, .van-cell__value {
    flex: auto;
}
</style>
